import React from "react";
import Controls from "src/components/form/controls/Controls";

const contextOption = [
  {
    id: "success",
    name: "success",
  },
  {
    id: "error",
    name: "error",
  },
];

const TTSContextPanelOptional = ({ contextType, setContextType }) => {
  return (
    <div style={{ display: "flex" }}>
      <Controls.Select
        name="contextType"
        label="Type"
        value={contextType}
        onChange={(e) => setContextType(e.target.value)}
        options={contextOption}
        style={{ width: "120px" }}
      />
    </div>
  );
};

export default TTSContextPanelOptional;
